import { ProductConfiguration } from "./productConfiguration.types";
import LicensePlate from "./visuals/licensePlate/licensePlate.component";

export const productConfigurations: ProductConfiguration[] = [
    {
        productSKUs: [
            "341819",
            "487684",
            "509641",
            "892028",
            "1054490",
            "1054491",
            "1054492",
            "1054493",
        ],
        visual: LicensePlate,
        productSubType: "licenseplates",
        configPaths: ["chosenLicensePlateType", "chosenLicensePlateText"],
        previewPath: "chosenLicensePlateText",
    },
];

export const getProductConfiguration = (
    sku: string,
): ProductConfiguration | undefined => {
    return productConfigurations.find(({ productSKUs }) =>
        productSKUs.includes(sku),
    );
};

export const isConfigurableProduct = (sku: string): boolean =>
    productConfigurations.some(({ productSKUs }) => productSKUs.includes(sku));
